import { GridComparatorFn } from '@mui/x-data-grid-premium'
import { RequestPriorityEnum } from '@omnea-app/packages/universal/requests/requestPriority'

export const requestPriorityEnumToNumberMap = {
  [RequestPriorityEnum.LOWEST]: 1,
  [RequestPriorityEnum.LOW]: 2,
  [RequestPriorityEnum.MEDIUM]: 3,
  [RequestPriorityEnum.HIGH]: 4,
  [RequestPriorityEnum.HIGHEST]: 5,
}

export const requestPriorityEnumDataGridComparator: GridComparatorFn<RequestPriorityEnum | null> = (p1, p2) => {
  const rank1 = p1 == null ? 0 : requestPriorityEnumToNumberMap[p1]
  const rank2 = p2 == null ? 0 : requestPriorityEnumToNumberMap[p2]
  return rank2 - rank1
}
